import { AWSConnectorService } from './../../providers/aws-connector';
import { environment } from '../../../environments/environment';
import { FirebaseService } from '../../providers/firebase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../models/client';
import { cars } from '../../models/cars';
import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { MenuItem } from "primeng/api";

export interface Message {
  severity?: string;
  summary?: string;
  detail?: string;
  id?: any;
}

@Component({
  selector: 'app-component-file-upload',
  templateUrl: './component-file-upload.component.html',
  styleUrls: ['./component-file-upload.component.css']
})
export class ComponentFileUploadComponent implements OnInit {
  key: string;
  clientData: Client;
  cars = cars;
  msgs: Message[];
  uploadedFiles: any[] = [];
  items: MenuItem[];

  constructor(
    public afService: FirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    public aws: AWSConnectorService
  ) { }

  ngOnInit() {
    this.items = [
      {
        label: 'New',
        icon: 'fa-plus',
        items: [{
          label: 'Bucket',
          command: (event) => {
            //event.originalEvent: Browser event
            //event.item: menuitem metadata
            console.log(event)
            if (event.originalEvent.type == 'click') {

            }
          }
        }]
      },
      {
        label: 'Create',
        icon: 'fa-edit',
        items: [
          { label: 'S3 Bucket', icon: 'fa-mail-forward' },
          { label: 'Folder', icon: 'fa-mail-reply' }
        ]
      },
      {
        label: 'Help',
        icon: 'fa-question',
        items: [
          {
            label: 'Contents'
          },
          {
            label: 'Search',
            icon: 'fa-search',
            items: [
              {
                label: 'Text',
                items: [
                  {
                    label: 'Workspace'
                  }
                ]
              },
              {
                label: 'File'
              }
            ]
          }
        ]
      },
      {
        label: 'Actions',
        icon: 'fa-gear',
        items: [
          {
            label: 'Edit',
            icon: 'fa-refresh',
            items: [
              { label: 'Save', icon: 'fa-save' },
              { label: 'Update', icon: 'fa-save' },
            ]
          },
          {
            label: 'Other',
            icon: 'fa-phone',
            items: [
              { label: 'Delete', icon: 'fa-minus' }
            ]
          }
        ]
      },
      {
        label: 'Quit', icon: 'fa-minus'
      }
    ];

    this.route.params.subscribe((params) => {
      this.key = params["key"];
      this.afService.getClientInfo(this.key).subscribe(clientData => {
        // sub.unsubscribe();
        this.clientData = clientData;

      });
    });

  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  createNewS3Bucket() {

  }

  onUpload(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'File Uploaded', detail: '' });
  }

  imageUploader(e, type) {
    console.log(e);

  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-file-upload/component-file-upload.component.ts